<template>
  <div class="versionManage">
    <div class="versionManage-main">
      <module-title title="版本管理">
        <div class="right">
          <el-button
            type="primary"
            size="medium"
            icon="el-icon-plus"
            @click="opAddOrEdit('add')"
          >
            新增升级
          </el-button>
          <el-button type="primary" size="medium" icon="el-icon-arrow-left" @click="$emit('back')">
            返回
          </el-button>
        </div>
      </module-title>
      <div class="versionManage-main-contain">
        <el-table
          v-loading="listLoading"
          :data="applicationList"
          highlight-current-row
          fit
          element-loading-text="Loading"
          class="list-table"
        >
          <el-table-column type="index" width="55" align="center" label="序号" />
          <el-table-column label="应用名称" prop="cunwAppName" align="center" />
          <el-table-column label="升级类型" prop="platformTypeName" align="center" />
          <el-table-column label="升级方式" prop="forcedUpgrade" align="center">
            <template slot-scope="scope">
              <!-- <span v-show=" scope.row.forcedUpgrade===3">自检</span> -->
              <span v-show=" scope.row.forcedUpgrade===2">推荐</span>
              <span v-show=" scope.row.forcedUpgrade===1">强制</span>
            </template>
          </el-table-column>
          <el-table-column label="版本号" prop="versionName" align="center" />
          <el-table-column v-if="versionPrpos.platformTypeId==='1003000003'" label="基础迭代号" prop="versionNumber" align="center" />
          <el-table-column v-if="versionPrpos.platformTypeId==='1003000003'" label="最新迭代号" prop="versionNumberMax" align="center" />
          <el-table-column label="更新时间" prop="createDate" align="center" width="168">
            <template slot-scope="scope">
              {{ scope.row.createDate }}
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              {{ scope.row.releaseType===0?'未发布':'已发布' }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="300px">
            <template slot-scope="scope">
              <el-button
                v-show="scope.row.releaseType===0||versionPrpos.platformTypeId==='1003000003'||scope.row.releaseType===4"
                type="primary"
                size="small"
                icon="el-icon-edit"
                @click="opAddOrEdit('edit',scope.row)"
              >
                编辑
              </el-button>
              <el-button
                v-show="scope.row.releaseType!==0"
                type="primary"
                size="small"
                icon="el-icon-view"
                @click="opAddOrEdit('view',scope.row)"
              >
                详情
              </el-button>
              <el-button
                v-show="scope.row.releaseType===0"
                type="success"
                size="small"
                icon="el-icon-position"
                @click="publishAddApplication(scope.row)"
              >
                发布
              </el-button>
              <el-button
                v-show="scope.row.releaseType===0||scope.row.releaseType===4"
                type="primary"
                size="small"
                icon="el-icon-delete"
                @click="deleteAddApplication(scope.row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :total="versionSearchForm.total"
          :page.sync="versionSearchForm.pageNum"
          :limit.sync="versionSearchForm.pageSize"
          @pagination="pageCurriculumList"
          @handleSizeChange="handleSizeChange"
        />
      </div>
    </div>
    <!-- 新增编辑版本 -->
    <el-dialog
      v-if="hiddenVariable.dialogEditVisible"
      :close-on-click-modal="false"
      :visible.sync="hiddenVariable.dialogEditVisible"
      :title="handleTitle"
      width="700px"
      @close="handleDialogClose"
    >
      <h2 class="platName">
        {{ versionPrpos.platformTypeName }}
      </h2>
      <el-form
        ref="addApplicationForm"
        :model="addApplicationForm"
        :rules="handleRules"
        label-position="right"
        label-width="150px"
      >
        <div v-if="versionPrpos.platformTypeId==='1003000003'">
          <el-form-item label="厂商：" prop="vendorCode">
            <el-select
              v-model="addApplicationForm.vendorCode"
              name="vendorCode"
              size="medium"
              class="handle-form-input"
            >
              <!-- <el-option label="全部" value /> -->
              <el-option
                v-for="item in vendorList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>

          <el-form-item
            label="更新包："
            prop="apkPackage"
          >
            <span v-if="!viewShow">
              <span v-if="handleType === 'edit'">{{ addApplicationForm.apkPackage }}</span>
              <upload-file
                :props="{serveCode:'apk',
                         accept:'.zip',
                         uploadtype:'rom',
                         packageCheck:true,
                         type:['application/vnd.android.package-archive','application/x-zip-compressed']}"
                @uploadSucess="uploadSucessFn"
                @fileUploading="fileUploadingFn"
                @beforeUpload="beforeUploadFn"
              >
                <el-button
                  :loading="fileUploading"
                  size="small"
                  type="primary"
                  icon="el-icon-upload2"
                  :disabled="handleTitle === '编辑版本'?true:false"
                >{{ fileUploading?'上传文件中...':'点击上传' }}
                </el-button>
              </upload-file>
            </span>
            <span v-else>{{ addApplicationForm.apkPackage }}</span>
          </el-form-item>
          <el-form-item
            label="MD5值："
            prop="md5Value"
          >
            <el-input
              v-if="!viewShow"
              v-model="addApplicationForm.md5Value"
              name="md5Value"
              class="handle-form-input"
              :disabled="true"
            />
            <span v-else>{{ addApplicationForm.md5Value }}</span>
          </el-form-item>
          <el-form-item label="最大迭代号：" prop="versionNumberMax">
            <el-input
              v-model="addApplicationForm.versionNumberMax"
              maxlength="10"
              name="versionNumberMax"
              class="handle-form-input"
              :disabled="true"
            />
          </el-form-item>
        </div>
        <div v-if="versionPrpos.platformTypeId==='1003000002'">
          <el-form-item
            label="apk包："
            prop="apkPackage"
          >
            <span v-if="!viewShow">
              <span v-if="handleType === 'edit'">{{ addApplicationForm.apkPackage }}</span>
              <upload-file
                :props="{serveCode:'apk',
                         accept:'.apk',
                         packageCheck:true,
                         type:['application/vnd.android.package-archive']}"
                @uploadSucess="uploadSucessFn"
                @fileUploading="fileUploadingFn"
                @apkParser="apkParserFn"
                @beforeUpload="beforeUploadFn"
              >
                <el-button
                  :loading="fileUploading"
                  size="small"
                  type="primary"
                  icon="el-icon-upload2"
                  :disabled="handleTitle === '编辑版本'?true:false"
                >{{ fileUploading?'上传文件中...':'点击上传' }}
                </el-button>
              </upload-file>
            </span>
            <span v-else>{{ addApplicationForm.apkPackage }}</span>
          </el-form-item>

          <el-form-item
            label="包名："
            prop="packageName"
          >
            <el-input
              v-if="!viewShow"
              v-model="addApplicationForm.packageName"
              name="packageName"
              class="handle-form-input"
              :disabled="true"
            />
            <span v-else>{{ addApplicationForm.packageName }}</span>
          </el-form-item>
          <el-form-item
            label="MD5值："
            prop="md5Value"
          >
            <el-input
              v-if="!viewShow"
              v-model="addApplicationForm.md5Value"
              name="md5Value"
              class="handle-form-input"
              :disabled="true"
            />
            <span v-else>{{ addApplicationForm.md5Value }}</span>
          </el-form-item>
        </div>
        <div v-if="versionPrpos.platformTypeId==='1003000001'">
          <el-form-item
            label="appleid："
            prop="appleid"
          >
            <el-input v-if="!viewShow" v-model="addApplicationForm.appleid" name="appleid" class="handle-form-input" maxlength="200" />
            <span v-else>{{ addApplicationForm.appleid }}</span>
          </el-form-item>
          <el-form-item
            label="bundleid："
            prop="bundleid"
          >
            <el-input v-if="!viewShow" v-model="addApplicationForm.bundleid" name="bundleid" class="handle-form-input" maxlength="200" />
            <span v-else>{{ addApplicationForm.bundleid }}</span>
          </el-form-item>
        </div>

        <el-form-item label="迭代号：" prop="versionNumber">
          <el-input
            v-if="!viewShow"
            v-model="addApplicationForm.versionNumber"
            maxlength="10"
            name="versionNumber"
            class="handle-form-input"
            :disabled="platDisabled"
            @input="inputNumD"
          />
          <span v-else>{{ addApplicationForm.versionNumber }}</span>
        </el-form-item>
        <el-form-item label="版本号：" prop="versionName">
          <el-input
            v-if="!viewShow"
            v-model="addApplicationForm.versionName"
            maxlength="10"
            name="versionName"
            class="handle-form-input"
            :disabled="platDisabled&&versionPrpos.platformTypeId!=='1003000003'"
            @input="inputNum"
          />
          <span v-else>{{ addApplicationForm.versionName }}</span>
        </el-form-item>

        <el-form-item label="更新方式：" prop="forcedUpgrade">
          <el-radio-group v-if="!viewShow" v-model="addApplicationForm.forcedUpgrade">
            <!-- <el-radio :label="3"  v-if="versionPrpos.platformTypeId!=='1003000003'">自检</el-radio> -->
            <el-radio :label="2">
              推荐
            </el-radio>
            <el-radio :label="1">
              强制
            </el-radio>
          </el-radio-group>
          <span v-else>
            <span v-show="addApplicationForm.forcedUpgrade===1">强制</span>
            <span v-show="addApplicationForm.forcedUpgrade===2">推荐</span>
            <!-- <span v-show="addApplicationForm.forcedUpgrade===3">自检</span> -->
          </span>
        </el-form-item>
        <el-form-item label="版本描述：" prop="remark">
          <el-input
            v-if="!viewShow"
            v-model="addApplicationForm.remark"
            type="textarea"
            :rows="6"
            placeholder="请输入内容"
            class="handle-form-input"
            maxlength="1000"
            show-word-limit
          />
          <span v-else>{{ addApplicationForm.remark }}</span>
        </el-form-item>
      </el-form>
      <div v-if="!viewShow" slot="footer" class="dialog-footer">
        <el-button size="medium" @click="handleDialogClose">
          取消
        </el-button>
        <el-button
          :loading="ajaxLoading"
          type="primary"
          size="medium"
          @click="handleAddUpgrade"
        >
          {{ ajaxLoading?'Loading':'确定' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import { formatTimeToStr } from '@/utils/index';
// import JsZip from 'jszip';// zip压缩
import {
  getDictsType
} from '@/api/productOperation/common/applicationManage';
import {
  addApplicationVersion,
  editApplicationVersion,
  cunwappupgradestask,
  updateApplicationUpgradeStatus
} from '@/api/systemMaintenance/upgradeManage/versionManage';
import {
  updateApplicationUpgradeStatusRom,
  editApplicationVersionRom,
  getPreReleaseList
} from '@/api/systemMaintenance/upgradeManage/preRelease';
export default {
  name: 'VersionManage',
  props: {
    versionPrpos: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      viewShow: false,
      platformType: [],
      zipContent: null,
      ajaxLoading: false,
      platDisabled: false,
      // 弹框标题
      handleType: 'add',
      handleTitle: '新增版本',
      // 所有控制显示隐藏变量
      hiddenVariable: {
        dialogEditVisible: false
      },
      // 搜索表单
      versionSearchForm: {
        appType: 2,
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      addApplicationForm: {
        apkPackage: '', //  升级包地址
        forcedUpgrade: 1, // 是否强制升级
        md5Value: '', // md5值
        packageName: '', //  包名
        remark: '', // 备注
        versionName: '', // 版本名称
        versionNumber: '', // 版本号
        absolutePath: '',
        logoUrl: '',
        appleid: '',
        bundleid: '',
        vendorCode: '',
        cunwAppId: this.versionPrpos.cunwAppId,
        fileSize: ''
      },
      listLoading: false, // 表格刷新loading
      multipleSelection: [], // 表格多选,
      applicationList: [],
      vendorList: [], //  终端列表
      platformList: [], //  平台列表
      handleRow: {},

      fileUploading: false,
      handleRules: {
        versionNumber: [
          { required: true, message: '迭代号不能为空', trigger: 'blur' }
        ],
        platformTypeId: [
          { required: true, message: '平台类型不能为空', trigger: 'blur' }
        ],
        versionName: [
          { required: true, message: '版本号不能为空', trigger: 'blur' }
        ],
        forcedUpgrade: [
          { required: true, message: '更新方式不能为空', trigger: 'change' }
        ]
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; // 如果没有后面的-8.64e7就是不可以选择今天
        },
        selectableRange: `${new Date().getHours()}:${new Date().getMinutes()}:${new Date().getSeconds()} - 23:59:59`
      } // 时间控件限制
    };
  },
  computed: {

    formatTimeToStr() {
      return formatTimeToStr;
    }
  },
  mounted() {
    this.fetchApplicationList();
    this.fetchvendorList();
  },
  methods: {
    inputNumD(val) {
      this.addApplicationForm.versionNumber = val.replace(/[^\d]/g, '').replace(/^0{1,}/g, '');
    },
    inputNum(val) {
      this.addApplicationForm.versionName = val.replace(/[^a-zA-Z\d.]/g, '').replace(/^[0.]{1,}/g, '');
    },
    uploadSucessFn(val) {
      this.$set(this.addApplicationForm, 'absolutePath', val.relativePath);
      this.$set(this.addApplicationForm, 'apkPackage', val.absolutePath);
      this.$set(this.addApplicationForm, 'md5Value', val.md5Value);
      this.$set(this.addApplicationForm, 'versionName', val.versionName);
      this.$set(this.addApplicationForm, 'versionNumber', val.versionCode);
      if (val.versionNumberMax) {
        this.$set(this.addApplicationForm, 'versionNumberMax', val.versionNumberMax);
      }
      this.$set(this.addApplicationForm, 'packageName', val.package);
      this.$set(this.addApplicationForm, 'fileSize', val.file.size);
      this.fileUploading = false;
    },
    fileUploadingFn(val) {
      this.fileUploading = val;
    },
    apkParserFn(val) {
      const ApkParser = require('app-info-parser/src/apk');
      const parser = new ApkParser(val.file);
      console.log(val);
      parser.parse().then(result => {
        this.uploadSucessFn({ ...result, ...val });
        this.addApplicationForm.versionSecretKey = val.versionSecretKey;
      }).catch(err => {
        console.log('err ----> ', err);
      });
    },

    // 分页
    pageCurriculumList(obj) {
      this.versionSearchForm.pageNum = obj.page;
      this.fetchApplicationList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.versionSearchForm.pageNum = 1;
      this.versionSearchForm.pageSize = obj.limit;
      this.fetchApplicationList();
    },
    // 条件查询
    handleSearchFilter() {
      this.versionSearchForm.pageNum = 1;
      this.versionSearchForm.pageSize = 10;
      this.fetchApplicationList();
    },

    // 打开新增编辑弹框
    opAddOrEdit(type, row) {
      var handleRules = null;
      if (this.versionPrpos.platformTypeId === '1003000002') {
        handleRules = {
          apkPackage: [
            { required: true, message: '升级包不能为空', trigger: 'blur' }
          ],
          md5Value: [
            { required: true, message: 'MD5值不能为空', trigger: 'blur' }
          ],
          packageName: [
            { required: true, message: '包名不能为空', trigger: 'blur' }
          ]
        };
      } else if (this.versionPrpos.platformTypeId === '1003000001') {
        handleRules = {
          appleid: [
            { required: true, message: 'appleid不能为空', trigger: 'blur' }
          ],
          bundleid: [
            { required: true, message: 'bundleid不能为空', trigger: 'blur' }
          ]
        };
      } else if (this.versionPrpos.platformTypeId === '1003000003') {
        handleRules = {
          vendorCode: [
            { required: true, message: '厂商不能为空', trigger: 'blur' }
          ],
          apkPackage: [
            { required: true, message: '升级包不能为空', trigger: 'blur' }
          ],
          md5Value: [
            { required: true, message: 'MD5值不能为空', trigger: 'blur' }
          ]
        };
      }
      this.handleRules = {
        ...handleRules,
        ...this.handleRules
      };
      this.handleType = type;
      this.hiddenVariable.dialogEditVisible = true;
      if (type === 'add') {
        this.viewShow = false;
        this.handleTitle = '新增版本';
        if (this.versionPrpos.platformTypeId === '1003000001') { this.platDisabled = false; } else {
          this.platDisabled = true;
        }
        this.addApplicationForm = {};
      } else {
        this.platDisabled = true;
        this.handleRow = row;
        const {
          apkPackage,
          forcedUpgrade,
          md5Value,
          packageName,
          remark,
          upgradeWay,
          versionName,
          versionNumber,
          versionNumberMax,
          appleid,
          bundleid,
          vendorCode,
          fileSize
        } = row;
        this.addApplicationForm = {
          apkPackage,
          forcedUpgrade,
          md5Value,
          packageName,
          remark,
          upgradeWay,
          versionName,
          versionNumber,
          versionNumberMax,
          appleid,
          bundleid,
          vendorCode,
          cunwAppId: this.versionPrpos.cunwAppId,
          fileSize
        };
        if (type === 'view') {
          this.viewShow = true;
          this.handleTitle = '查看详情';
        } else {
          this.handleTitle = '编辑版本';
          this.viewShow = false;
        }
      }
    },
    // 重置
    handleDialogClose() {
      this.addApplicationForm = {
        apkPackage: '',
        forcedUpgrade: '',
        md5Value: '',
        packageName: '',
        remark: '',
        upgradeWay: 1,
        versionName: '',
        versionNumber: '',
        appleid: '',
        bundleid: '',
        cunwAppId: this.versionPrpos.cunwAppId,
        vendorCode: '',
        fileSize: '',
        versionNumberMax: ''
      };
      this.fileUploading = false;
      this.hiddenVariable.dialogEditVisible = false;
    },
    // 删除应用
    deleteAddApplication(row) {
      // 移除成员
      this.$confirm(`确定要删除该应用升级么?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          if (this.versionPrpos.platformTypeId === '1003000003') {
            updateApplicationUpgradeStatusRom({ ids: [row.id], status: -1 });
          } else {
            updateApplicationUpgradeStatus({ ids: [row.id], status: -1 });
          }
        }

        )
        .then(res => {
          this.$notify.success({
            title: 'Success',
            message: '删除成功',
            showClose: false,
            duration: 2000
          });
          this.fetchApplicationList();
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 新增编辑应用升级
    handleAddUpgrade() {
      this.$refs['addApplicationForm'].validate(valid => {
        if (valid) {
          this.ajaxLoading = true;
          if (this.handleType === 'add') {
            this.addApplicationForm.cunwAppId = this.versionPrpos.cunwAppId;
            this.addApplicationForm.appType = 2;
            this.addApplicationForm.upgradeWay = 1;
            const option = {
              apkPackage: this.addApplicationForm.apkPackage,
              forcedUpgrade: this.addApplicationForm.forcedUpgrade,
              md5Value: this.addApplicationForm.md5Value,
              packageName: this.addApplicationForm.packageName,
              remark: this.addApplicationForm.remark,
              upgradeWay: 1,
              versionName: this.addApplicationForm.versionName,
              versionNumber: this.addApplicationForm.versionNumber,
              appleid: this.addApplicationForm.appleid,
              bundleid: this.addApplicationForm.bundleid,
              cunwAppId: this.versionPrpos.cunwAppId,
              vendorCode: this.addApplicationForm.vendorCode,
              fileSize: this.addApplicationForm.fileSize,
              versionNumberMax: this.addApplicationForm.versionNumberMax
            };
            this.addApplicationForm.versionSecretKey ? option.versionSecretKey = this.addApplicationForm.versionSecretKey : null;
            addApplicationVersion(option)
              .then(result => {
                this.$notify.success({
                  title: 'Success',
                  message: '添加成功',
                  showClose: false,
                  duration: 2000
                });
                this.ajaxLoading = false;
                this.hiddenVariable.dialogEditVisible = false;
                this.fetchApplicationList();
              })
              .catch(err => {
                console.log(err);
                this.ajaxLoading = false;
              });
          } else {
            const option = {
              apkPackage: this.addApplicationForm.apkPackage,
              forcedUpgrade: this.addApplicationForm.forcedUpgrade,
              md5Value: this.addApplicationForm.md5Value,
              packageName: this.addApplicationForm.packageName,
              remark: this.addApplicationForm.remark,
              upgradeWay: 1,
              versionName: this.addApplicationForm.versionName,
              versionNumber: this.addApplicationForm.versionNumber,
              appleid: this.addApplicationForm.appleid,
              bundleid: this.addApplicationForm.bundleid,
              cunwAppId: this.versionPrpos.cunwAppId,
              vendorCode: this.addApplicationForm.vendorCode,
              fileSize: this.addApplicationForm.fileSize,
              versionNumberMax: this.addApplicationForm.versionNumberMax
            };
            if (this.versionPrpos.platformTypeId === '1003000003') {
              editApplicationVersionRom(this.handleRow.id, option)
                .then(result => {
                  this.$notify.success({
                    title: 'Success',
                    message: '编辑成功',
                    showClose: false,
                    duration: 2000
                  });
                  this.ajaxLoading = false;
                  this.hiddenVariable.dialogEditVisible = false;
                  this.fetchApplicationList();
                })
                .catch(err => {
                  console.log(err);
                  this.ajaxLoading = false;
                });
            } else {
              editApplicationVersion(this.handleRow.id, option)
                .then(result => {
                  this.$notify.success({
                    title: 'Success',
                    message: '编辑成功',
                    showClose: false,
                    duration: 2000
                  });
                  this.ajaxLoading = false;
                  this.hiddenVariable.dialogEditVisible = false;
                  this.fetchApplicationList();
                })
                .catch(err => {
                  console.log(err);
                  this.ajaxLoading = false;
                });
            }
          }
        } else {
          console.log('error submit!!');
          this.ajaxLoading = false;
          return false;
        }
      });
    },

    // 发布版本
    publishAddApplication(row) {
      this.$confirm(`确定要发布该应用版本么?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          var option = {
            cunwAppId: row.cunwAppId,
            cunwAppUpgradeId: row.id,
            upgradeType: 4,
            upgradeStatus: 4,
            releaseWay: 1,
            remark: row.remark
          };
          return cunwappupgradestask(option);
        })
        .then(res => {
          this.$notify.success({
            title: 'Success',
            message: '发布成功',
            showClose: false,
            duration: 2000
          });
          this.fetchApplicationList();
        })
        .catch(err => {
          console.log(err);
        });
    },

    // 获取应用列表
    fetchApplicationList() {
      this.listLoading = true;
      this.versionSearchForm.cunwAppId = this.versionPrpos.cunwAppId;
      this.versionSearchForm.releaseType = 4;
      getPreReleaseList(this.versionSearchForm)
        .then(result => {
          this.applicationList = result.data.list;
          this.versionSearchForm.total = result.data.total;
          this.listLoading = false;
        })
        .catch(err => {
          console.log(err);
          this.listLoading = false;
          this.applicationList = [];
          this.versionSearchForm.total = 0;
        });
    },

    // 获取终端字典
    fetchvendorList() {
      getDictsType('vendor_type')
        .then(result => {
          this.vendorList = result.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    async beforeUploadFn(file, callback) {
      var msg = '';
      var flag = this.packageNameCheck(file);
      if (!flag) {
        return callback({ data: { flag: false, msg: '包名校验不正确，请重新上传!' }});
      }
      return callback({ data: { flag, msg }});
    },
    // 上传应用包名检查
    packageNameCheck(file) {
      var name = file.name.split('_');
      if (name.length !== 6) {
        return false;
      }
      const pattern = new RegExp(/^[\d\s\.*]+$/);
      if (!pattern.test(name[3]) || !pattern.test(name[4])) {
        return false;
      }
      return true;
    }

  }
};
</script>
<style lang="scss">
.versionManage .el-textarea .el-input__count{
  position: static;
}
.versionManage {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
}
</style>
<style lang="scss" scoped>
.versionManage {
  padding-bottom: 20px;
  .el-date-editor.el-input {
    margin-left: 20px;
  }
  .handle-form-input {
    width: 80%;
  }
  .platName{
    font-size: 24px;
     margin-left:30px;
    margin-bottom:20px;
  }
}
</style>

